module.exports = __webpack_public_path__ + "media/images/emblems/Lotzwil-coat_of_arms-9e20cf69fbdfe7b3cf55d3424c388f65.svg";